export default "__VITE_ASSET__BKsDN5lh__"